<script>
  import options from './CardListContact.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <!-- Backend dev notes: colorthemes not set by editor in this component -->
  <section class="be-card-list be-card-list-contact be-color-theme--yellow-yellow" 
    :class="{ 'be-card-list-contact--one-card' : cardsResult.length === 1 ? true : false }">

    <div class="be-card-list__content-wrapper">
      <template v-if="title !== null">
        <h2 class="be-font-heading-2 be-card-list__title">{{title}}</h2>
      </template>
      <template v-if="leader !== null">
        <p class="be-font-paragraph-2 be-card-list__leader">{{ leader }}</p>
      </template>

      <ul class="be-card-list__cards-list-wrapper">

          <template v-for="(card, index) in cardsResult" :key="index">  
              <li>
                <ContactCard :result="card" />
              </li>
          </template>
        
      </ul>

    </div>
  </section> 
</template>
